import './FieldNodeList.scss';
import React from 'react';
import { FieldNode, FieldNodeProps } from './FieldNode';

export interface FieldNodeListFieldProps {
	label?: string;
	nodes: FieldNodeProps[];
}

export const FieldNodeList: React.FC<FieldNodeListFieldProps> = ({ label = 'Nodes', nodes }) => {
	if (!nodes.length) {
		return null;
	}

	return (
		<div
			className='field-node-container'
			data-after-content={ label }>
			{ nodes && nodes.map((node) => <FieldNode
				{ ...node }
				key={ node.name } />) }
		</div>
	);
};
